import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { CustomFormContext } from "../../CustomForm";
import { ErrorInfo } from "../../types";
import { prepareContent } from "../../helpers";
import { FormHelperText, Grid, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

interface CustomSelectProps {
  alias: string;
  header: string;
  readOnlyField?: boolean;
  disabled?: boolean;
  valueProp?: string;
  labelProp?: string;
  required?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const ValueSlider = ({
  alias,
  header = "",
  required = false,
  readOnlyField = false,
  disabled = false,
  className = "",
  style = {},
}: CustomSelectProps) => {
  const { t } = useTranslation();
  const {
    fieldValue,
    dataIsSet,
    getValidationErrors,
    setDataDispatch,
    errorsAreSet,
    tempData,
    showErrors,
  } = React.useContext(CustomFormContext);
  const [value, setValue] = React.useState<number | null>(null);
  const [errors, setErrors] = React.useState<ErrorInfo[] | null>(null);

  const valuetext = (value: number) => {
    return `${value}`;
  };

  React.useEffect(() => {
    if (!dataIsSet || !errorsAreSet) {
      return;
    }
    const data = fieldValue(alias);

    if (data === undefined) {
      return;
    }

    const errors = getValidationErrors(alias);
    setValue(data);
    if (errors) {
      setErrors(errors);
    }
  }, [dataIsSet, errorsAreSet, tempData]);

  const handleSave = () => {
    const data = prepareContent(value, alias);
    setDataDispatch({
      type: "UPDATE_CONTENT",
      payload: data,
    });
  };

  React.useEffect(() => {
    setErrors(getValidationErrors(alias));
  }, [getValidationErrors, alias]);

  return (
    <Grid container>
      <Stack direction="column" spacing={2}>
        <Typography variant="h6">
          {t("forms.eq_5d_5l.value_slider.description_1")}
        </Typography>
        <Typography variant="h6">
          {t("forms.eq_5d_5l.value_slider.description_2")}
        </Typography>
        <Typography variant="h6">
          {t("forms.eq_5d_5l.value_slider.value", { value })}
        </Typography>
      </Stack>
      <Grid container sx={{ width: "100%", justifyContent: "center" }}>
        <Box sx={{ width: 200, height: 500 }}>
          <Slider
            aria-label="Temperature"
            sx={{ color: "#26a69a" }}
            orientation="vertical"
            getAriaValueText={valuetext}
            valueLabelDisplay="auto"
            step={1}
            value={value!}
            onChangeCommitted={(event, value) => {
              handleSave();
            }}
            onChange={(event, value) => {
              setValue(value as number);
            }}
          />
        </Box>

        {showErrors &&
          errors?.map((info, index) => (
            <FormHelperText key={index} variant="standard">
              <Typography variant="caption" color="red">
                {info.message}
              </Typography>
            </FormHelperText>
          ))}
      </Grid>
    </Grid>
  );
};

ValueSlider.fieldType = "ValueSlider";

export default ValueSlider;
